/**
 * Возвращает страну и город/регион маршрута в языке, соответствующем локали интерфейса.
 * Использует country_en / city_or_region_en для английского, иначе country / city_or_region.
 *
 * @param {object} route - Маршрут (country, city_or_region, country_en, city_or_region_en и camelCase варианты)
 * @param {string} [locale] - Локаль интерфейса (например i18n.language): 'en', 'ru', 'en-US' и т.д.
 * @returns {{ country: string, cityOrRegion: string }}
 */
export const getRouteLocationDisplay = (route, locale = '') => {
  if (!route || typeof route !== 'object') {
    return { country: '', cityOrRegion: '' };
  }
  const lang = (locale || 'en').toString().trim().split('-')[0];
  const isEn = lang === 'en';

  const country = isEn
    ? (route.country_en ?? route.countryEn ?? route.country ?? '').toString().trim()
    : (route.country ?? '').toString().trim();
  const cityOrRegion = isEn
    ? (route.city_or_region_en ?? route.cityOrRegionEn ?? route.city_or_region ?? route.cityOrRegion ?? '').toString().trim()
    : (route.city_or_region ?? route.cityOrRegion ?? '').toString().trim();

  return { country, cityOrRegion };
};
